import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://prehiring-backend.planeasy.co.in",
  withCredentials: true,
});

export { apiClient };
